"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var validator_1 = __importDefault(require("validator"));
var VariableRegistry = /** @class */ (function () {
    function VariableRegistry() {
        var _this = this;
        this.variables = {};
        this.datatypes = Array();
        this.counters = {};
        this.getVariables = function () { return _this.variables; };
        this.getDatatypes = function () { return _this.datatypes; };
    }
    VariableRegistry.prototype.register = function (name, value) {
        if (value === undefined || value == null) {
            return "null";
        }
        if (this.counters[name] === undefined) {
            this.counters[name] = 0;
        }
        this.counters[name] = this.counters[name] + 1;
        var varName = name + this.counters[name];
        var clonedValue = JSON.parse(JSON.stringify(value));
        if (Array.isArray(clonedValue)) {
            clonedValue.forEach(function (it) { return delete it._typeName; });
        }
        else if (clonedValue._isWrapper === true) {
            clonedValue = clonedValue._wrappedValue;
        }
        else {
            delete clonedValue._typeName;
        }
        this.variables[varName] = clonedValue;
        this.datatypes.push("$" + varName + ":" + this.toType(value));
        return "$" + varName;
    };
    VariableRegistry.prototype.toType = function (value) {
        if (Array.isArray(value)) {
            if (value.length > 0) {
                return "[" + this.toTypeSingle(value[0]) + "]";
            }
            throw new Error('Could not extract name for empty array');
        }
        else {
            return this.toTypeSingle(value) + "!";
        }
    };
    VariableRegistry.prototype.toTypeSingle = function (value) {
        switch (typeof (value)) {
            case "string": return this.resolveStringType(value);
            case "boolean": return "Boolean";
            case "number": return "Int";
            case "object": return this.objectName(value);
            default: return value;
        }
    };
    VariableRegistry.prototype.objectName = function (obj) {
        try {
            // @ts-ignore
            return obj.name();
        }
        catch (e) {
            // @ts-ignore
            if (obj._typeName != null) {
                // @ts-ignore
                return obj._typeName;
            }
            throw new Error('Could not extract name for ' + JSON.stringify(obj));
        }
    };
    VariableRegistry.prototype.resolveStringType = function (obj) {
        if (validator_1.default.isUUID(obj)) {
            return "Uuid";
        }
        return "String";
    };
    return VariableRegistry;
}());
exports.default = VariableRegistry;
//# sourceMappingURL=VariableRegistry.js.map